<template lang="pug">
.container-wrapper
  ChangingNetwork(v-if='isChangingNetwork')
  error
  el-dialog(:close-on-click-modal="false",
    :visible.sync="showPlaylogVisible",
    @close='showPlaylogVisible = false',
    fullscreen
  )
    Playlog(
      v-if='showPlaylogVisible === true',
      ref='Playlog',
      :entity='playlogEntity',
      @finished='showPlaylogVisible = false',
      @showPlaylogForNetwork='showPlaylogForNetwork',
      @showPlaylogForMedium='showPlaylogForMedium',
      @showPlaylogForDevice='showPlaylogForDevice'
    )
  el-dialog(:close-on-click-modal="false",
    :visible.sync="showUpgradeExtensionVisible",
    @close='showUpgradeExtensionVisible = false',
    fullscreen
  )
    UpgradeExtension(
      v-if='showUpgradeExtensionVisible === true',
      ref='UpgradeExtension',
      :upgradedExtensionMediumId='upgradedExtensionMediumId',
      @finished='reloadLeftComponent("Library"); showUpgradeExtensionVisible = false'
    )
  el-dialog(:visible.sync="showUpdatableDesktopsVisible", @close='showUpdatableDesktopsVisible = false', :close-on-click-modal="false")
    UpdateContentToStartReportList(v-if='showUpdatableDesktopsVisible', @finished='showUpdatableDesktopsVisible = false')
  el-dialog(:close-on-click-modal="false",
      :visible.sync="healthMonitoringVisible",
      @close='healthMonitoringVisible = false',
      fullscreen
    )
      HealthMonitoring(v-if="healthMonitoringVisible", ref='HealthMonitoring')
  .container-main(@click='closeAllContextMenus')
    //- shortkey has to be in a component so let's put in el-header
    el-header.main-header(
      v-shortkey="shortkeys",
      @shortkey.native="keyboardShortcut"
    )
    .el-menu-top
      .menu-item.logo
        .logo-content(id="Layout-logo" @click="goHome()")
      .menu-right
        .menu-item-right
          el-dropdown(id="Layout-liveModeDropdown" :hide-on-click='false')
            span.el-dropdown-link {{ $t('Live Mode') }}
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeHeartbeatCheckbox",
                  v-model='liveModeLocal.heartbeat',
                  @change='setLiveMode',
                  :title='$t("Heartbeat")')
                  span(style="font-size:12px;") {{ $t("Heartbeat") }}
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeContentUpdateCheckbox",
                  v-model='liveModeLocal.contentUpdateProgress',
                  @change='setLiveMode',
                  :title='$t("Content Update Progress")')
                  span(style="font-size:12px;") {{ $t("Content Update Progress") }}
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeContentPendingCheckbox",
                  v-model='liveModeLocal.contentPending',
                  @change='setLiveMode',
                  :title='$t("Content Pending")')
                  span(style="font-size:12px;") {{ $t("Content Pending") }}
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeFailedRequestsCheckbox",
                  v-model='liveModeLocal.failedRequests',
                  @change='setLiveMode',
                  :title='$t("Failed Requests")')
                  span(style="font-size:12px;") {{ $t("Failed Requests") }}
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeMediaConvertionsCheckbox",
                  v-model='liveModeLocal.mediaConvertions',
                  @change='setLiveMode',
                  :title='$t("Media Convertions")')
                  span(style="font-size:12px;") {{ $t("Media Convertions") }}
              el-dropdown-item
                el-checkbox(
                  id="Layout-liveModeLibraryUpdatesCheckbox",
                  v-model='liveModeLocal.library',
                  @change='setLiveMode',
                  :title='$t("Library updates")')
                  span(style="font-size:12px;") {{ $t("Library updates") }}
        el-button.menu-button(
          type="text",
          :title="$t('Network Health Report')",
          id="Layout-networkHealthReportButton",
          @click="healthMonitoringVisible = true"
        )
          font-awesome-icon(icon="medkit")
        .menu-item-right.network-location
          .network-location-content
            el-dropdown(id="Layout-changeNetworkDropdown", trigger="click", @command="changeNetwork")
              el-button(
                size="mini",
                type="text",
                :title="$t('Change network')",
                id="Layout-changeNetworkButton"
              )
                font-awesome-icon(icon="wifi")
                span(v-if='currentUserNetwork') &nbsp; {{ currentUserNetwork.name }}
              el-dropdown-menu(slot='dropdown')
                el-dropdown-item(:command="network.id", v-for='(network, index) in userAccesibleNetworks', :key='network.id', :id="'Layout-changeNetworkOption' + network.id")
                  span {{ network.name }}
        .menu-item-right.to-be-updated-counter
          .to-be-updated-counter-content()
            el-button(
              size="mini",
              type="text",
              :title="$t('Send pending changes to players')",
              id="Layout-pendingChangesButton1",
              :disabled='modifications.length === 0',
              @click="updateScreens"
            )
              font-awesome-icon(icon="upload")
              span &nbsp; {{ modifications.length }}
        .menu-item-right.site-language
          el-dropdown(trigger="click", @command="changeLang")
            el-button(
              size="mini",
              type="text",
              :title="$t('Choose language')",
              id="Layout-chooseLanguageButton"
            )
              img(:src='getLocaleImageSource(this.$i18n.locale)')
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item(:command="language", v-for="language in siteLanguages", :key='language', :id="'Layout-languageOption-' + language")
                img.dropdown-language-image(:src='getLocaleImageSource(language)')
        .menu-item-right.fixed-right.nick
          UserSubMenu
        .menu-item-right.fixed-right.admin-button
          .admin-button-content(id="Layout-advancedMenuButton" type='text', @click='toggleAdvancedMenuVisible()', :title="$t('Advanced menu')")
            font-awesome-icon(icon="cogs")
    AdvancedMenu(v-if='advancedMenuVisible', @reloadLeftComponent='reloadLeftComponent', @changeNetwork='changeNetwork')
    .menu-item.library-switch-container
      .device-media-switch-content
        .device-media-switch-buttons
          .device-media-switch(
            v-for='n in librariesCount',
            :id="'Layout-switchLibraryButton' + n"
            @click="chooseLibrary(n)"
          )
            .device-media-switch-text(:class="{ selected: (libraryChosen === n && leftPanelChosen === 'library')}")
              u {{ n }}
              span &nbsp; - &nbsp;
              span(:title='libraries[n].path')
                | {{ libraries[n].name }}
              span(v-if='librariesCount === n && n > 1')
                span &nbsp;
                i.el-icon-close.muted(@click.stop='deleteLibrary(n)')
          .device-media-switch(id="Layout-addLibraryButton" v-if='librariesCount < 5', @click="addLibrary")
            .device-media-switch-text(class="selected")
              i.el-icon-plus.muted
          .device-media-switch(id="Layout-mediaListSwitch" @click="setLeftPanelType('mediaList')", :title='$t("Media List")')
             .device-media-switch-text(:class="{ selected: leftPanelChosen === 'mediaList' }")
              font-awesome-icon.muted(icon="bars")
    .menu-item.device-media-switch-container
      .device-media-switch-content
        .device-media-switch-buttons(:title="$t('Ctrl+Alt+D to switch context')")
          .device-media-switch(id="Layout-devicesListSwitch" @click="setRightPanelType('devices')")
            .device-media-switch-text(:class="{ selected: rightPanelChosen === 'devices' }")
              span {{ $t(tabs.screens) }} &nbsp;-&nbsp; {{ rightComponent === 'screenGroups' ? $t('Groups') : $t('List') }}
          .device-media-switch(v-if='!mediumIsNull && !(getBreadcrumbs().length === 0)', @click="setRightPanelType('media')")
            .device-media-switch-text.media-editor(:class="{ selected: rightPanelChosen === 'media' }")
              span.breadcrumb(v-for="(item, index) in getBreadcrumbs()", :key="item.id", :id="'Layout-deviceSwitch' + item.id")
                font-awesome-icon.slash(v-if='index > 0', icon="chevron-right")
                span.name(:class="{ active: (index === (getBreadcrumbs().length - 1)) }", @click="breadcrumbClicked(index)", :title='item.fullname') {{ item.name }}
                font-awesome-icon.slash(v-if='index > 0 && (index === getBreadcrumbs().length - 1)', icon="times", @click="breadcrumbClicked(index - 1)")
    .main-content-row(v-loading="isLoading")
      .left-clumn(:class="{ focused: focusSide === 'left' }")
        .grid-content(@click='hideAdvancedMenu()')
          .tagFilterMedia
            TagFilterMedia(v-if="tagFilterMediaVisible", side="left")
          Library(
            v-if='librariesCount >= index',
            v-for='(library, index) of libraries', :key='index',
            v-show='libraryChosen == index && leftPanelChosen === "library"',
            ref='library',
            side="left",
            :library='index',
            @loadedFolder='adjustLibraryTabName'
            @reloadLeftComponent='reloadLeftComponent',
            @reloadLocalPlayLists='reloadLocalPlayLists',
            @reloadMediaEditor='reloadMediaEditor',
            @refreshPlaylist='refreshPlaylist',
            @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
            @loadPlayListTree='loadPlayListTree',
            @rightClickAction='rightClickLeftPanelAction',
            @getBackToMediaListInLeftPanel='getBackToMediaListInLeftPanel',
            @closeRightPanelContextMenu='closeRightPanelContextMenus()'
          )
          MediaList(
            v-show='leftPanelChosen === "mediaList"',
            ref="mediaList",
            side="left",
            @reloadLeftComponent='reloadLeftComponent',
            @reloadLocalPlayLists='reloadLocalPlayLists',
            @reloadMediaEditor='reloadMediaEditor',
            @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
            @loadPlayListTree='loadPlayListTree',
            @rightClickAction='rightClickLeftPanelAction',
            @getBackToMediaListInLeftPanel='getBackToMediaListInLeftPanel',
            @closeRightPanelContextMenu='closeRightPanelContextMenus()'
          )
      .middle-column(@dragenter='dragEnterMiddleColumn', @dragleave='dragLeaveMiddleColumn', @click="closeRightPanelContextMenus()")
          Linker(
            ref='linker',
            @linkerJobDone="linkerJobDone",
            @reloadLeftComponent="reloadLeftComponent",
            @loadEditMediumInMediaEditor = 'loadEditMediumInMediaEditor',
            @uploadRequested = 'requestUpload',
            @createFolderRequested = 'requestCreateFolder'
          )
      .right-column(:class="{ focused: focusSide === 'right' }")
        .grid-content(@click='hideAdvancedMenu()', v-show="currentMedium && rightPanelChosen === 'media'")
          MediumEditor(
            :mediumId='currentMedium.id',
            ref="mediaEditor",
            @reloadLeftComponent="reloadLeftComponent",
            @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
            @loadMediumUsageInMediaEditor='loadMediumUsageInMediaEditor',
            @loadPathInLibrary='loadPathInLibrary',
            @loadPlayListTree='loadPlayListTree',
            @mediumDeleted='reloadLeftComponent',
            @getBackToMediaListInRightPanel='getBackToMediaListInRightPanel'
          )
        .grid-content(@click='hideAdvancedMenu()', v-show="rightPanelChosen === 'devices'")
          component(
            v-bind:is='rightComponent',
            side="right",
            ref="rightComponent",
            :mediumId='currentMedium.id',
            :PlayItemId='PlayItemId',
            @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
            @loadPlayListTree='loadPlayListTree',
            @mediumDeleted='reloadLeftComponent',
            @reloadRightComponent='reloadRightComponent',
            @reloadLeftComponent='reloadLeftComponent',
            @rightClickAction='rightClickRightPanelAction',
            @getBackToMediaListInRightPanel='getBackToMediaListInRightPanel',
            @closeLeftPanelContextMenu='closeLeftPanelContextMenu()'
          )
  .status-bar.status-bar-media( :class="{ focused: focusSide === 'left' }", @click='closeAllContextMenus')
    StatusBarMedia
  .status-bar-server(v-if='wsStatusMalfunction')
    span {{$t('Server slow down or malfunction detected.')}}
    p {{$t('You may experience some inconvenience...')}}
    p {{  this.$store.state.Error.ws_status.status }}
    p {{  this.$store.state.Error.ws_status.modified  }}
  .status-bar.status-bar-devices(:class="{ focused: focusSide === 'right' }", @click='closeAllContextMenus')
    StatusBarDevices
</template>

<script>
import Files from './File/List'
import MediumIcon from './Common/MediumIcon'
import MediaList from './Medium/MediaList'
// import PlaylistTree from './Medium/PlaylistTree'
import Library from './Medium/Library'
import MediumEditor from './Medium/MediumEditor'
import FileUpload from './File/Upload'
import Linker from './Linker/Linker'
import devices from './Device/List'
import screenGroups from './Device/GroupsHeader'
import error from './Error/error'
// import deviceHealthReport from './Device/HealthReport'
import HealthMonitoring from './Device/HealthMonitoring'
import TagFilterMedia from './Medium/TagFilterMedia'
import TagFilterDevices2 from './Device/TagFilterDevices2'
import AdvancedMenu from './AdvancedMenu'
import StatusBarMedia from './StatusBarMedia'
import StatusBarDevices from './StatusBarDevices'
import textUtils from './Common/textUtils.mixin'
import userUtils from './Common/userUtils.mixin'
import Playlog from './Common/Playlog'
import UpgradeExtension from './Medium/UpgradeExtension'
import UpdateContentToStartReportList from './Device/UpdateContentToStartReportList'
import UserSubMenu from './LayoutComponents/UserSubMenu.vue'
import ChangingNetwork from './LayoutComponents/ChangingNetwork.vue'
import Vue from 'vue'

export default {
  mixins: [textUtils, userUtils],
  name: 'Layout-Full',
  components: {
    Files,
    FileUpload,
    devices,
    screenGroups,
    Linker,
    error,
    MediumEditor,
    // PlaylistTree,
    Library,
    TagFilterMedia,
    TagFilterDevices2,
    AdvancedMenu,
    StatusBarMedia,
    StatusBarDevices,
    MediumIcon,
    UpdateContentToStartReportList,
    Playlog,
    HealthMonitoring,
    UpgradeExtension,
    MediaList,
    UserSubMenu,
    ChangingNetwork
  },
  props: [
    'leftPanel',
    'rightPanel',
    'mediumEditor'
  ],
  beforeRouteUpdate (to, from, next) {
    this.leftComponent = to.params.leftPanel
    this.rightComponent = to.params.rightPanel
    if (to.params.leftPanel.indexOf('media_') !== -1) {
      let mediaType = to.params.leftPanel.substring(6)
      this.leftComponent = 'Media'
      this.$store.dispatch('Medium/setTypeInFilter', ['left', this.$store.state.Medium.media_types.find(type => type.name === mediaType)])
    }

    if (to.params.rightPanel.indexOf('media_') !== -1) {
      let mediaType = to.params.rightPanel.substring(6)
      this.rightComponent = 'Media'
      this.$store.dispatch('Medium/setTypeInFilter', ['right', this.$store.state.Medium.media_types.find(type => type.name === mediaType)])
    }

    let medium = this.$store.state.Medium.media_list.find(medium => (medium.id === parseInt(to.params.mediumEditor.substring(7))))
    if (medium) {
      this.currentMedium = medium
    } else {
      this.$store.dispatch('User/setRightPanelChosen', 'devices')
    }
    next()
  },

  data () {
    return {
      activeIndex: '1',
      isCollapse: true,
      isLoading: false,
      leftComponent: 'Library',
      rightComponent: 'devices',
      previousRightComponent: undefined,
      currentMedium: { id: 0 },
      PlayItemId: undefined,
      libraryMedium: undefined,
      playlistMedium: undefined,
      showUpdatableDesktopsVisible: false,
      showPlaylogVisible: false,
      playlogEntity: undefined,
      advancedMenuVisible: false,
      focusSide: 'left',
      siteLanguages: ['en', 'pl'],
      healthMonitoringVisible: false,
      showUpgradeExtensionVisible: false,
      upgradedExtensionMediumId: undefined,
      shortkeys: {
        selectAll: ['ctrl', 'a'],
        selectNone: ['ctrl', 'd'],
        cutSelected: ['ctrl', 'x'],
        pasteSelected: ['ctrl', 'v'],
        newFolder: ['ctrl', 'alt', 'n'],
        uploadMedia: ['ctrl', 'alt', 'u'],
        toggleRightPanelType: ['ctrl', 'alt', 'd'],
        toggleFocus: ['shift', 'tab'],
        activateLibrary1: ['alt', '1'],
        activateLibrary2: ['alt', '2'],
        activateLibrary3: ['alt', '3'],
        activateLibrary4: ['alt', '4'],
        activateLibrary5: ['alt', '5'],
        activateMediaList: ['alt', 'l']
      },
      tabs: {
        library: 'Library',
        mediaList: 'Playlists',
        screens: 'Screens'
      },
      // Maps are not iterable in Vue2 :(
      librariesCount: 1,
      libraryChosen: 1,
      libraries: {
        1: { name: this.$t('Library'), path: this.$t('Home') },
        2: { name: this.$t('Library'), path: this.$t('Home') },
        3: { name: this.$t('Library'), path: this.$t('Home') },
        4: { name: this.$t('Library'), path: this.$t('Home') },
        5: { name: this.$t('Library'), path: this.$t('Home') }
      },
      liveModeLocal: undefined
    }
  },
  watch: {
    // TODO - make live mode on demand
    libraryChosen: async function (newVal, oldVal) {
      if (newVal === oldVal || !newVal) return
      await this.reloadLeftComponent()
    },
    liveMode: async function (newVal, oldVal) {
      this.liveModeLocal = JSON.parse(JSON.stringify(this.$store.state.User.liveMode))
    }
  },
  created () {
    this.liveModeLocal = JSON.parse(JSON.stringify(this.$store.state.User.liveMode))
    this.rightComponent = this.$router.history.current.params.rightPanel
    this.$i18n.locale = this.$store.state.User.user.language
  },
  methods: {
    window () {
      return window
    },
    setLiveMode () {
      this.$store.dispatch('User/setLiveMode', this.liveModeLocal)
    },
    getRefForLibrary (index) {
      return `library${index}`
    },
    activateLibrary (num) {
      if (this.$store.state.Medium.media_reloading) return
      const library = parseInt(num)
      if (library <= this.librariesCount && library >= 1) {
        this.setLeftPanelType('library')
        this.libraryChosen = library
        return true
      }
      return false
    },
    addLibrary () {
      if (this.$store.state.Medium.media_reloading) return
      this.setLeftPanelType('library')
      this.librariesCount++
    },
    deleteLibrary () {
      if (this.$store.state.Medium.media_reloading) return
      this.librariesCount--
      if (this.libraryChosen > this.librariesCount) {
        this.libraryChosen = this.librariesCount
      }
    },
    chooseLibrary (library) {
      if (this.$store.state.Medium.media_reloading) return
      this.setLeftPanelType('library')
      this.libraryChosen = library
    },
    adjustLibraryTabName (data) {
      this.libraries[data.library].name = data.name
      this.libraries[data.library].path = data.path
    },
    showPlaylogForMedium (mediumId) {
      this.playlogEntity = { type: 'Medium', id: mediumId }
    },
    showPlaylogForDevice (deviceId) {
      this.playlogEntity = { type: 'Device', id: deviceId }
    },
    showPlaylogForNetwork () {
      this.playlogEntity = { type: 'Network', id: this.currentUserNetwork.id }
    },
    closeRightPanelContextMenus () {
      if (this.$refs.rightComponent && this.$refs.rightComponent.closeRightClickMenu()) this.$refs.rightComponent.closeRightClickMenu()
      if (this.$refs.mediaEditor && this.$refs.mediaEditor.closeRightClickMenu()) this.$refs.mediaEditor.closeRightClickMenu()
    },
    closeLeftPanelContextMenu () {
      for (const $library of this.$refs.library) {
        if ($library && $library.closeRightClickMenu()) $library.closeRightClickMenu()
      }
      if (this.$refs.mediaList && this.$refs.mediaList.closeRightClickMenu()) this.$refs.mediaList.closeRightClickMenu()
    },
    closeAllContextMenus () {
      this.closeRightPanelContextMenus()
      this.closeLeftPanelContextMenu()
    },
    dragEnterMiddleColumn () {
      this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
      this.$store.dispatch('Medium/setDropAllowed', false)
    },
    dragLeaveMiddleColumn () {
    },
    requestUpload (type) {
      this.setLeftPanelType('library')
      Vue.nextTick(() => {
        this.$refs.library[this.libraryChosen - 1].triggerSelectFiles(type)
      })
    },
    requestCreateFolder () {
      this.setLeftPanelType('library')
      Vue.nextTick(() => {
        this.$refs.library[this.libraryChosen - 1].openCreateFolderDialog()
      })
    },
    getBreadcrumbs () {
      const result = []
      const maxCharacters = parseInt(window.innerWidth / 1920 * 100)
      const desiredNameStringLength = parseInt((maxCharacters - this.$store.state.Medium.breadcrumbs.length * 6) / this.$store.state.Medium.breadcrumbs.length)
      for (const breadcrumbMediumId of this.$store.state.Medium.breadcrumbs) {
        const medium = this.$store.state.Medium.media_list.find(medium => medium.id === breadcrumbMediumId)
        if (!medium) return []
        let name = ''
        if (medium.type === 'PlayListDesktop') {
          name = this.fullNameOfDesktopPlaylist(medium)
        } else {
          name = medium.name
        }
        result.push({
          id: medium.id,
          type: medium.type,
          name: this.shortenStringWithDots(name, desiredNameStringLength),
          fullname: medium.name
        })
      }
      return result
    },
    breadcrumbClicked (index) {
      this.$store.dispatch('Medium/stripBreadcrumbs', index)
      const medium = this.$store.state.Medium.media_list.find(medium => medium.id === this.$store.state.Medium.breadcrumbs[index])
      this.loadEditMediumInMediaEditor(medium)
    },
    pushRoute (left, right) {
      this.$router.push({ path: '/layout-full/' + left + '/' + right + '/' + this.$route.params.mediumEditor })
    },
    goHome () {
      this.pushRoute('Library', 'devices')
    },
    toggleAdvancedMenuVisible () {
      this.advancedMenuVisible = !this.advancedMenuVisible
    },
    hideAdvancedMenu () {
      this.advancedMenuVisible = false
    },
    // linkerJobDone (data) {
    linkerJobDone (data) {
      if (data === 'replaceInPlaylist' || data === 'assignToPlaylists') {
        this.$refs.mediaEditor.reloadData(data)
        return
      }

      if (this.$refs.mediaEditor && data !== 'create' && data !== 'assignToDevices') {
        this.$refs.mediaEditor.reloadData()
      }
      if (!data || !data.startsWith('assign')) {
        for (const library of this.$refs.library) {
          library.reloadData()
        }
      }
      if (this.$refs.rightComponent && data !== 'create' && data !== 'delete') {
        this.$refs.rightComponent.reloadData()
      }
    },
    reloadLeftComponent (component) {
      if (component) this.leftComponent = component
      this.pushRoute(this.leftComponent, this.rightPanel)
      Vue.nextTick(() => {
        if (this.leftPanelChosen === 'library') {
          this.$refs.library[this.libraryChosen - 1].reloadFolder()
        } else {
          this.$refs.mediaList.reloadData()
        }
      })
    },
    reloadRightComponent (component) {
      if (component) this.rightComponent = component
      this.pushRoute(this.leftPanel, this.rightComponent)
      let self = this
      Vue.nextTick()
        .then(() => {
          self.$refs.rightComponent.reloadData()
        })
    },
    reloadMediaEditor (component) {
      this.$refs.mediaEditor.reloadData()
    },
    refreshPlaylist () {
      this.$refs.mediaEditor.refreshPlaylist()
    },
    reloadLocalPlayLists (component) {
      if (this.$refs.rightComponent.reloadLocalPlaylistsCache) {
        this.$refs.rightComponent.reloadLocalPlaylistsCache()
      }
    },
    openLibrary () {
      this.$router.push({ path: '/layout-full/Library/' + this.rightPanel + '/' + this.$route.params.mediumEditor })
    },
    openFiles () {
      this.$router.push({ path: '/layout-full/Files/' + this.rightPanel + '/' + this.$route.params.mediumEditor })
    },
    getBackToMediaListInLeftPanel () {
      this.$router.go(-1)
    },
    getBackToMediaListInRightPanel () {
      this.$router.go(-1)
    },
    loadMediumUsageInMediaEditor (medium) {
      this.$router.push({ path: '/layout-full/' + this.leftPanel + '/' + this.rightPanel + '/medium,' + medium.id })
      this.$store.dispatch('User/setRightPanelChosen', 'media')
      this.$nextTick(_ => {
        this.$refs.mediaEditor.showComponent('MediumInPlaylists')
      })
    },
    loadPathInLibrary (path) {
      this.$router.push({ path: '/layout-full/Library/' + this.rightPanel + '/' + this.$route.params.mediumEditor })
      this.setLeftPanelType('library')
      this.$nextTick(_ => {
        this.$refs.library[this.libraryChosen - 1].loadPath(path)
      })
    },
    loadEditMediumInMediaEditor (medium) {
      this.$router.push({ path: '/layout-full/' + this.leftPanel + '/' + this.rightPanel + '/medium,' + medium.id })
      this.$store.dispatch('User/setRightPanelChosen', 'media')
      this.$nextTick(_ => {
        if (medium.type.startsWith('PlayList') && !medium.type.startsWith('PlayListLayout')) {
          this.$refs.mediaEditor.showComponent('PlayListEditor')
        } else if (medium.type.startsWith('PlayListLayout')) {
          this.$refs.mediaEditor.showComponent('LayoutEditorSmall')
        }
        this.refreshPlaylist()
      })
    },
    loadPlayListTree (playlistMedium) {
      this.$router.push({ path: '/layout-full/playListTree,' + playlistMedium.id + '/' + this.rightPanel + '/' + this.$route.params.mediumEditor })
    },
    async rightClickLeftPanelAction (data) {
      const { action, medium } = data
      switch (action) {
        case 'showPlaylogMedium':
          this.playlogEntity = { type: 'Medium', id: medium.id }
          this.showPlaylogVisible = true
          this.closeRightPanelContextMenus()
          break
        case 'deleteMedia':
          this.$refs.linker.showDelete()
          this.closeRightPanelContextMenus()
          break
        case 'duplicateMedia':
          this.$refs.linker.addChoiceMade('PlayList')
          this.closeRightPanelContextMenus()
          break
        case 'createLayout':
          this.$refs.linker.addChoiceMade('PlayListLayout')
          this.closeRightPanelContextMenus()
          break
        case 'createPlaylist':
          this.$refs.linker.addChoiceMade('PlayList')
          this.closeRightPanelContextMenus()
          break
        case 'assignMedia':
          this.$refs.linker.showAssign()
          this.closeRightPanelContextMenus()
          break
        case 'replaceMediaByName':
          this.$refs.linker.showReplaceByName()
          this.closeRightPanelContextMenus()
          break
        case 'showPlayListContent':
          this.$store.dispatch('Medium/clearBreadcrumbs')
          this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
          this.loadEditMediumInMediaEditor(medium)
          this.$nextTick(_ => {
            this.$refs.mediaEditor.showComponent('PlayListEditor')
          })
          break
        case 'showMediumUsage':
          this.$store.dispatch('Medium/clearBreadcrumbs')
          this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
          this.loadEditMediumInMediaEditor(medium)
          this.$nextTick(_ => {
            this.$refs.mediaEditor.showComponent('MediumInPlaylists')
          })
          break
        case 'replaceMedium':
          this.$refs.linker.showReplace('mediumReplace', medium)
          this.closeRightPanelContextMenus()
          break
        case 'replacePlayItem':
          this.closeRightPanelContextMenus()
          this.$refs.linker.showReplace('playitemReplace', medium)
          break
        case 'duplicatePlaylist':
          for (const library of this.$refs.library) {
            library.loading = true
          }
          if (!medium.type.startsWith('PlayList')) return
          // TODO. Here make library busy visually
          await this.$store.dispatch('Medium/duplicatePlaylist', medium)
          for (const library of this.$refs.library) {
            library.reloadData()
          }
          break
        case 'duplicatePlaylistsRecoursive':
          console.log('duplicatePlaylistsRecoursive')
          this.closeRightPanelContextMenus()
          this.$refs.linker.showDuplicatePlaylistRecursive(true) // many playlists
          break
        case 'duplicatePlaylistRecursive':
          this.closeRightPanelContextMenus()
          this.$refs.linker.showDuplicatePlaylistRecursive()
          break
        case 'duplicatePlaylists':
          for (const library of this.$refs.library) {
            library.loading = true
          }
          for (const medium of this.$store.state.Medium.media_selected_left) {
            if (!medium.type.startsWith('PlayList')) return
            await this.$store.dispatch('Medium/duplicatePlaylist', medium)
          }
          for (const library of this.$refs.library) {
            library.reloadData()
          }
          break
        case 'upgradeExtension':
          this.upgradedExtensionMediumId = medium.id
          this.showUpgradeExtensionVisible = true
          break
        default:
          console.error('Unknow action')
          console.error(data)
          break
      }
    },
    rightClickRightPanelAction (data) {
      const { action, desktop } = data
      switch (action) {
        case 'showPlaylogDevice':
          this.playlogEntity = { type: 'Device', id: desktop.Device.id ? desktop.Device.id : desktop.Device }
          this.showPlaylogVisible = true
          this.closeRightPanelContextMenus()
          break
        case 'addToLocation':
          this.$refs.linker.showGroup()
          break
        default:
          console.error(`Layout/rightClickRightPanelAction - Unknown action`, data)
          break
      }
    },
    keyboardShortcut ($event) {
      if (document.querySelector('.dialog-container')) {
        return
      }
      switch ($event.srcKey) {
        case 'toggleRightPanelType':
          this.$store.dispatch('User/toggleRightPanelChosen')
          break
        case 'toggleFocus':
          this.focusSide = this.focusSide === 'left' ? 'right' : 'left'
          this.$store.dispatch('User/setFocusedSide', this.focusSide)
          break
        case 'selectAll':
          if (this.focusSide === 'left') {
            this.$refs.library[this.libraryChosen - 1].selectAll()
          } else {
            if (this.$refs.rightComponent) this.$refs.rightComponent.selectAll()
            if (this.$refs.mediaEditor) this.$refs.mediaEditor.selectAll()
          }
          break
        case 'cutSelected':
        case 'pasteSelected':
        case 'newFolder':
        case 'uploadMedia':
          this.$refs.library[this.libraryChosen - 1].keyboardAction($event.srcKey)
          break
        case 'selectNone':
          if (this.focusSide === 'left') {
            this.$refs.library[this.libraryChosen - 1].selectNone()
          } else {
            this.$refs.rightComponent.selectNone()
          }
          break
        case 'activateLibrary1':
        case 'activateLibrary2':
        case 'activateLibrary3':
        case 'activateLibrary4':
        case 'activateLibrary5':
          if (!this.activateLibrary($event.srcKey.match(/\d/))) {
          }
          break
        case 'activateMediaList':
          this.setLeftPanelType('mediaList')
          break
        case 'activateDevices':
          this.setRightPanelType('devices')
          break
        case 'activateMediaEditor':
          this.setRightPanelType('media')
          console.log('activateMediaEditor')
          break
        default:
          console.error('unknown shortcut for', $event.srcKey, $event)
      }
    },
    setRightPanelType (type) {
      this.$store.dispatch('User/setRightPanelChosen', type)
    },
    setLeftPanelType (type) {
      this.$store.dispatch('User/setLeftPanelChosen', type)
    },
    // FIXME DRY
    async changeNetwork (newNetworkId) {
      this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', '...LEAVING NETWORK', { root: true })
      // await this.$store.dispatch('Medium/clearList', {})
      // await this.$store.dispatch('Device/clearList', {})
      setTimeout(async () => {
        this.$store.commit('Medium/SET_SELECTED_LIBRARY_FOLDER', {})
        this.librariesCount = 0
        this.libraryChosen = 1
        this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [])
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
        await this.$store.dispatch('User/changeNetwork', newNetworkId)
        this.librariesCount = 1
        // await this.$store.dispatch('Device/getDeviceList')
        this.$nextTick(function () {
          this.$router.push({ path: '/layout-full/Library/devices/medium,0' })
        })
      }, 500)
    },
    updateScreens () {
      this.showUpdatableDesktopsVisible = true
    },
    async changeLang (lang) {
      this.$i18n.locale = lang
      await Vue.axios.post('user/setViewPreference', {
        language: lang
      })
      await this.$store.dispatch('User/getMe')
    },
    isActiveLang (lang) {
      return this.$i18n.locale === lang
    },
    getLocaleImageSource (locale) {
      return `/static/${locale}.svg`
    }
  },
  computed: {
    rightPanelChosen () {
      return this.$store.state.User.rightPanelChosen
    },
    leftPanelChosen () {
      return this.$store.state.User.leftPanelChosen
    },
    mediumIsNull () {
      return parseInt(this.$route.params.mediumEditor.substring(7)) === 0
    },
    tagFilterMediaVisible () {
      return this.$store.state.Medium.show_tag_filter
    },
    userAccesibleNetworks () {
      const networks = JSON.parse(JSON.stringify(this.$store.state.User.user.Networks))
      return networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) || []
    },
    // FIXME DRY
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userIsAdmin () {
      return this.userRoleNames.includes('superadministrator') || this.userRoleNames.includes('administrator')
    },
    userIsSuperAdmin () {
      return this.userRoleNames.includes('superadministrator')
    },
    modifications () {
      return this.$store.state.Device.desktops_affected
    },
    wsStatusMalfunction () {
      if (typeof this.$store.state.Error.ws_status === 'object') return false
      return this.$store.state.Error.ws_status.status !== 200 || this.$store.state.Error.ws_status.modified < new Date().now - 11 * 1000
    },
    liveMode () {
      return this.$store.state.User.liveMode
    },
    isChangingNetwork () {
      return this.$store.state.User.changing_network_status_media || this.$store.state.User.changing_network_status_devices
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../theme-m4b/src/common/var.scss";
.main-content-row {
  display: flex;
  height: calc(100vh - 80px);
  overflow: hidden;
  .left-clumn, .right-column {
    width: calc(100vw - 250px);
    .tagFilterDevices {
      border: 0px dashed pink;
      margin-left:11px;
    }
  }
  .middle-column {
    width: 170px;
    border: 2px solid $--color-primary;
    border-top: 0px;
    border-bottom: 0px;
    // background-color: $--color-white;;
  }
}
.advancedMenuRow {
  min-height: 200px;
  border-bottom: 2px solid $--color-primary-light-1;
  box-shadow: 0px 3px 3px 3px rgba(0,0,0,0.2);
  z-index: 1;
}

.status-bar {
  position: fixed;
  bottom: -5px;
  z-index: 3000;
  border: $--border-light;
  border-radius: 5px;
  min-width: 300px;
  background-color: $--page-background;
  &.focused {
    background-color: $--color-white;
    box-shadow: 0px 0px 2px 2px $--border-color-extra-light;
    border-color: $--border-color-extra-light;
  }
  &.status-bar-media {
    left: -5px;
  }
  &.status-bar-devices {
    right: -5px;
  }
}
.status-bar-server {
  position: fixed;
  z-index: 1000001;
  border: 1px solid $--color-danger;
  width: 300px;
  margin-left: calc(47.6vw - 150px);
  bottom: -2px;
  text-align: center;
  border-radius: 3px;
  background-color: rgba(#000, 0.25);
  color: $--color-text-regular;
  p {
    color: $--color-text-secondary;
  }
}
// .linker-container {
//   height: 100%;
//   border: 1px solid $--color-primary;
//   border-top: 1px solid rgba(255,255,255,0);
// }

.main-header {
  padding: 0px !important;
}
.dropdown-language-image {
  width: 18px;
  height: 13px;
}
.el-menu-top {
  background-color: $--color-white;
  border: $--border-light;
  display: flex;
  // justify-content: flex-start;
  border: 0px dotted red;
  height: 70px;
  .menu-right {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .menu-item-right {
      margin: 0px 10px;
    }
    .site-language {
      img {
        width: 18px;
        height: 13px;
      }

    }
    .nick {
      font-size: $--font-size-small;
    }
    .admin-button {
      .admin-button-content {
        font-size: 13px;
        color: $--color-text-primary;
        cursor: pointer;
      }
    }
  }
  @keyframes pulse-w {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .menu-item {
    &.logo  {
      // width: 25vw;
      .logo-content {
        height: 37px;
        width: 130px;
        cursor: pointer;
        background: url('/static/wave2-logo.svg') 100% no-repeat;
        background-size: contain;
        margin: 5px 0px 0px 10px;
      }
    }
    &.network-location {
      // width: 25vw;
      .network-location-content {
        display: flex;
        height: 57px;
        align-items: center;
      }
    }
    &.to-be-updated-counter {
      border: 0px dotted red;
      display: flex;
      align-items: center;
      margin-left: 30px;
      &.to-be-updated-counter-content {
        height: 57px;
      }
    }
  }
}
.library-switch-container {
  margin-right: 30px;
  margin-top: -55px;
  top: 13px;
  border: 0px solid pink;
}
.device-media-switch-container {
  margin-left: calc(50vw + 75px);
  margin-right: 30px;
  margin-top: -60px;
  top: 13px;
  border: 0px solid pink;
}
.device-media-switch-container, .library-switch-container {
  // position: fixed;
  .device-media-switch-content {
    height:60px;
    border: 0px dotted blue;
    .device-media-switch-buttons {
      display: flex;
      height:100%;
      border: 0px dotted green;
      margin-left: 10px;
      .device-media-switch {
        border: 0px dotted red;
        .device-media-switch-text {
          border: $--border-light;
          border-bottom: 0px;
          padding: 5px 10px;
          margin: 30px 10px 0px 0px;
          color: $--color-text-secondary;
          text-transform: uppercase;
          font-size: 12px;
          cursor: pointer;
          background-color: rgba($--color-primary, 1);
          &.selected {
            font-weight: bold;
            color: $--color-text-primary;
            background-color: $backgroundMainColor;
          }
          &.media-editor {
            margin-left: 8px;
            border-bottom: 0px dotted pink;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            .breadcrumb {
              .icon {
                margin-right: 10px;
              }
              .slash {
                margin: 0px 10px;
                color: $--color-text-regular;
              }
            }
          }
        }
      }
    }
  }
}
.el-dropdown-menu {
  overflow-y: auto;
  max-height: calc(50vh + 75px);
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutFull.vue